import { render, staticRenderFns } from "./WorkflowStateThresholdsGroupDetail.vue?vue&type=template&id=9586515c&"
import script from "./WorkflowStateThresholdsGroupDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateThresholdsGroupDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports